// extracted by mini-css-extract-plugin
export default {"label-container":"_3JlfBHF5","labelContainer":"_3JlfBHF5"};